import { render, staticRenderFns } from "./NotificacaoPush.vue?vue&type=template&id=c0e2cd4e&scoped=true&"
import script from "./NotificacaoPush.vue?vue&type=script&lang=js&"
export * from "./NotificacaoPush.vue?vue&type=script&lang=js&"
import style0 from "./NotificacaoPush.vue?vue&type=style&index=0&id=c0e2cd4e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0e2cd4e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCol,VIcon,VImg,VRow,VSimpleTable,VTooltip})
